export const shortcutsPanelBackdropStyles = {
  zIndex: ({ zIndex }) => zIndex.modal,
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  backdropFilter: 'blur(2px)',
};

export const shortcutsPanelContainerStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '420px',
  maxHeight: '70vh',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '12px',
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: '0px 16px 48px rgba(0, 0, 0, 0.16)',
  zIndex: ({ zIndex }) => zIndex.modal + 1,
  overflow: 'hidden auto',
  padding: '20px 24px',
  gap: '20px',
};

export const shortcutsPanelHeaderStyles = {
  color: ({ palette }) => palette.text.primary,
};

export const shortcutsPanelSectionStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

export const shortcutsPanelSectionHeaderStyles = {
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: ({ palette }) => palette.text.placeholder,
  paddingBottom: '4px',
};

export const shortcutsPanelRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '6px 0',
};

export const shortcutsPanelKeyStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '36px',
  padding: '3px 8px',
  lineHeight: 1,
  borderRadius: '4px',
  backgroundColor: ({ palette }) => palette.background.disabled,
  color: ({ palette }) => palette.text.dark,
  flexShrink: 0,
};

export const shortcutsPanelLabelStyles = {
  color: ({ palette }) => palette.text.dark,
  flex: 1,
  textAlign: 'right',
};
